<template>
  <span>
    <tooltip-status>
      <v-icon :color="color" size="12">lens</v-icon> 
      <span v-if="useText" :class="alarmClasses" class="ml-1">{{ text }}</span>
    </tooltip-status>
  </span>
</template>

<script>
import TooltipStatus from "@/components/Measures/TooltipStatus";

export default {
  name: "OnlineState",
  components: {
    TooltipStatus,
  },
  props: {
    colors: {
      default: () => ["primary", "red", "gray"],
    },
    texts: {
      default: () => ["Ativo", "Inativo", "-"],
    },
    data: [Object, Array],
    useText: {
      type: Boolean,
      default: false,
    },
    alarmClasses: {
      type: String,
      default: "font-14",
    },
  },
  data: () => ({
    _state: null,
    _circuitBreaker: null,
  }),
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (!data) return;

        if (!Array.isArray(data)) {
          data = [data];
        }
        this._state = data[0];

        if (data.length > 1) {
          this._circuitBreaker = data[1];
        }
      },
    },
  },
  computed: {
    color() {
      if (this._state && this._circuitBreaker) {
        return this.colors[this.circuitBreakerLogic()];
      }
      return this.colors[this.baseLogic()];
    },
    text() {
      if (this._state && this._circuitBreaker) {
        return this.texts[this.circuitBreakerLogic()];
      }
      return this.texts[this.baseLogic()];
    },
  },
  methods: {
    baseLogic(disabled, error, good) {
      if (this._state && this._state.check()) {
        return this._state.isActed() ? 1 : 0;
      }
      return 2;
    },
    circuitBreakerLogic() {
      if (!this._circuitBreaker.checkQuality()) {
        return 2;
      }
      if (this._circuitBreaker.isActed()) {
        return 1;
      }
      if (!this._state.checkQuality() || this._state.isActed()) {
        return 2;
      }
      return 0;
    },
  },
};
</script>

<style>
</style>